import { Component } from 'react';

/**
 * Captura cualquier error de render de la app para que no quede una pantalla en
 * blanco sin explicación. Tiene que ser un componente de clase: no existe
 * equivalente en hooks para componentDidCatch.
 *
 * Ojo: NO captura errores dentro de promesas/async (esos siguen siendo un
 * try/catch en quien llama).
 */
export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, errorInfo) {
        console.error('Error no controlado:', error, errorInfo);
    }

    render() {
        if (!this.state.error) {
            return this.props.children;
        }

        return (
            <div className="containerPortal" style={{ padding: '4rem 1rem', textAlign: 'center' }}>
                <h2>Algo no funcionó como esperábamos</h2>
                <p style={{ margin: '1rem 0rem' }}>
                    Podés recargar la página o volver al inicio. Si el problema sigue,
                    escribinos por WhatsApp.
                </p>
                <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'center' }}>
                    <button className="btn btn-warning" onClick={() => window.location.reload()}>
                        Recargar
                    </button>
                    <a className="btn btn-secondary" href="/">Ir al inicio</a>
                </div>
                {process.env.NODE_ENV === 'development' && (
                    <pre style={{ textAlign: 'left', marginTop: '2rem', whiteSpace: 'pre-wrap' }}>
                        {this.state.error.stack || String(this.state.error)}
                    </pre>
                )}
            </div>
        );
    }
}
